import { Button } from 'antd'
import { useCIMSTableContext } from '../../../CIMSTableContext'

function CollapseHeaderActionButton<T extends object>() {
  const { actions } = useCIMSTableContext<T>()
  const { onCollapse } = actions.header.collapse
  return <Button onClick={onCollapse}>Collapse All</Button>
}

export default CollapseHeaderActionButton
